import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UiProgressBarComponent } from '@uigy/shared/components/ui-progress-bar/ui-progress-bar.component';
import { VprOptions } from '@uigy/shared/plugins-grid/enums/vpr.enum';
import { LanguageService } from '@uigy/shared/services/language.service';
import { VprService } from '@uigy/shared/services/vpr.service';

@Component({
    selector: 'app-vpr-cell-renderer',
    imports: [
        UiProgressBarComponent
    ],
    templateUrl: './vpr-cell-renderer.component.html',
    styleUrl: './vpr-cell-renderer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VprCellRendererComponent implements ICellRendererAngularComp {
  public languageService = inject(LanguageService);
  public vpr?: number;
  public vprOption?: VprOptions;

  public agInit(params: ICellRendererParams): void {
    this.vpr = params.value;
    this.vprOption = VprService.getVPRScoreOption(params.value);
  }

  public refresh(): boolean {
    return false;
  }
}
